import VueRouter from 'vue-router';
import Vue from 'vue';
//import Index from './pages/index.vue';
import Hall from './pages/hall.vue';

Vue.use(VueRouter);

// 1. Определение компоненты маршрут.
// Из других import файл приходит в
//const Foo = {template: '<div>foo</div>'}
//const Bar = {template: '<div>bar</div>'}

// 2. Определите маршрут
// Каждый маршрут должен быть сопоставлен с компонентом. При этом "component" может быть
// По Vue.extend() cоздать конструктор компонента,
// Или, просто компонент конфигурации объекта.
// Позже мы обсудим вложенные маршрутизации.
const routes = [
    {
        path: '/',
        component: Hall
    },
    //{name: 'hall', path: '/hall/:id', component: Hall },

    /*
    {path: '/countdown', component: CountDown},
    {path: '/getmoney', component: Getmoney},
    {path: '/payout', component: Payout},
    {path: '/check', component: Check}
    */
];

// 3. Создать экземпляр маршрутизатора, а затем передать `routes` конфигурации
// Вы также можете пройти другие параметры конфигурации, но первый настолько прост, что.
const router = new VueRouter({
    routes // (Аббревиатура）эквивалентно routes: routes
});

export default router;


// WEBPACK FOOTER //
// ./vue-source/src/app/router.js